export const FETCH_ADS = 'FETCH_ADS';
export const SET_ADS = 'SET_ADS';

export const fetchAds = () => {
  return {
    type: FETCH_ADS,
  };
};

export const setAds = (ads) => {
  return {
    type: SET_ADS,
    payload: ads,
  };
};
